import React, { useEffect, useRef, useState } from "react";
import './ScalingWrapper.scss'

const ScalingWrapper = ({children, setIsMobile = () => {}, nonScaliable}) => {
  const elRef = useRef(null);
  const wrapperRef = useRef(null);
  const [aspectratio, setAspectratio] = useState("desktop");

  useEffect(() => {
    const wrapper = wrapperRef.current;

    function doResize() {
      const wrapperWidth = wrapper.offsetWidth;
      const wrapperHeight = wrapper.offsetHeight;

      if (nonScaliable === true) return
      if (wrapperWidth/wrapperHeight < 1) {
        setAspectratio("mobile");
        setIsMobile(true);
      } else {
        setAspectratio("desktop");
        setIsMobile(false);
      }
    }

    window.addEventListener("resize", doResize);
    doResize();

    return () => {
      window.removeEventListener("resize", doResize);
    };
  }, []);

  useEffect(() => {
    const el = elRef.current;
    const wrapper = wrapperRef.current;
    const elHeight = el.offsetHeight;
    const elWidth = el.offsetWidth;

    function doResize() {
      const scale = Math.min(
        wrapper.offsetWidth / elWidth,
        wrapper.offsetHeight / elHeight
      );

      el.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }

    doResize();

    const handleResize = () => {
      doResize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [aspectratio]);

  const childrenWithProps = React.Children.map(children, (child) => {
    return React.cloneElement(child, { aspectratio: aspectratio });
  });

  return (
    <div className="app-wrapper" ref={wrapperRef}>
      <div className={`scale-wrapper aspect-ratio-${aspectratio}`} ref={elRef}>
        {childrenWithProps}
      </div>
    </div>
  );
};

export default ScalingWrapper;
